import { createSlice } from "@reduxjs/toolkit";
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import { POOL_DATA } from "constants/constants";
import axiosGeneral from "helpers/axios/axiosGeneral";
import {
  setCreateNewAccountModal,
  setForgottenPasswordModal,
} from "./signInPageSlice";
import {
  setupSocketConnection,
  severSocketConnection,
} from "./channels/socketSlice";
import { selectCurrentTree, setCurrentTree } from "./efficeTreeSlice";
import { addBatchData } from "./efficeCacheSlice";
import { selectInviteEffice } from "./joinSlice";
import {
  checkDeviceAndBrowser,
  resetAllState,
  resetWebAppWithError,
  serverDownReset,
} from "./generalSlice";
import { setMyReadEffices } from "./myReadEfficesSlice";
import {
  adjustID,
  cleanEfficeList,
  setServerTime,
} from "helpers/efficeHelpers";
import { freshmanHere } from "helpers/freshman";
import { joinPersonalChannel } from "./channels/personalChannelSlice";
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

var userPoolOld = null;
var showSuccessDuration = 2500; //milliseconds

function deleteUserPoolOld(poolId, clientId) {
  userPoolOld = [poolId, clientId];
  setTimeout(() => {
    userPoolOld = null;
    return;
  }, 300000);
}

export const slice = createSlice({
  name: "auth",
  initialState: {
    tryingRegister: false,
    successRegister: false,
    tryingSignIn: false,
    signInError: null,
    userPending: null,
    registerError: null,
    userResetPending: null,
    userResetError: null,
    currentUserAttributes: null,
    //needs to be undefined in order to know when we have checked user authentication (because it will be set to NULL after checking)
    currentUser: null,
  },
  reducers: {
    tryingRegister: (state, action) => {
      state.tryingRegister = action.payload;
      if (action.payload) {
        state.registerError = null;
      }
    },
    userPending: (state, action) => {
      state.userPending = action.payload;
    },
    registerError: (state, action) => {
      state.registerError = action.payload;
    },
    signInError: (state, action) => {
      state.signInError = action.payload;
    },
    successRegister: (state, action) => {
      state.successRegister = action.payload;
    },
    userResetError: (state, action) => {
      state.userResetError = action.payload;
    },
    userResetPending: (state, action) => {
      state.userResetPending = action.payload;
    },
    tryingSignIn: (state, action) => {
      state.tryingSignIn = action.payload;
      if (action.payload) {
        state.signInError = null;
      }
    },
    setCurrentUserAttributes: (state, action) => {
      if (action.payload == null) {
        state.currentUserAttributes = {
          given_name: " ", // put a space inside so it doesnt flash undefined whilst loading
          family_name: " ",
          email: null,
          avatar_key: null,
          id: null,
          email_verified: null,
        };
      } else {
        state.currentUserAttributes = action.payload;
      }
    },
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    resetSignInPage: (state) => {
      state.tryingRegister = false;
      state.successRegister = false;
      state.tryingSignIn = false;
      state.signInError = null;
      state.userPending = null;
      state.registerError = null;
      state.userResetPending = null;
      state.userResetError = null;
    },
  },
});
export const {
  tryingRegister,
  userPending,
  registerError,
  signInError,
  successRegister,
  userResetError,
  userResetPending,
  tryingSignIn,
  setCurrentUserAttributes,
  setCurrentUser,
  resetSignInPage,
} = slice.actions;

export const getCurrentToken = () =>
  new Promise((res, rej) => {
    var theUser = userPool.getCurrentUser();
    if (!theUser) {
      rej();
      if (!selectInviteEffice(getState()))
        resetWebAppWithError(
          "You have been automatically signed out",
          "You likely signed out from another tab or browser window. If not, trying restarting your browser."
        );
      return;
    }
    theUser.getSession(function (err, session) {
      if (err) {
        alert(err.message || JSON.stringify(err));
        if (session)
          window.efs_debug &&
            window.log("Session not valid: " + session.isValid());
        else window.efs_debug && window.log("Session not valid: Session null");
        rej();
      } else {
        window.efs_debug && window.log("Session Valid: " + session.isValid());
        let idToken = session.getIdToken().jwtToken;
        // process.env.NODE_ENV !== "production" && console.log(idToken);
        res(idToken);
      }
    });
  });

export const editName =
  ({ givenName, familyName }) =>
  async (dispatch, getState) => {
    userPool.getCurrentUser().getSession((err, sesh) => {
      if (err) {
        alert(err.message || JSON.stringify(err));
        if (sesh)
          window.efs_debug &&
            window.log("Edit name, session not valid: " + sesh.isValid());
        else
          window.efs_debug &&
            window.log("Edit name, session not valid: Session null");
        return;
      }
      let idToken = sesh.getIdToken().jwtToken;
      axiosGeneral
        .patch(
          `/me/name`,
          { given_name: givenName, family_name: familyName },
          {
            headers: {
              Authorization: "Bearer " + idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let current = selectCurrentUserAttributes(getState());
          dispatch(
            setCurrentUserAttributes({
              ...current,
              given_name: response.data.user.given_name,
              family_name: response.data.user.family_name,
            })
          );
        });
    });
  };
export const tryRegister =
  ({ firstName, lastName, email, password }) =>
  async (dispatch) => {
    var attributeList = [];
    attributeList.push(
      new CognitoUserAttribute({
        Name: "given_name",
        Value: firstName,
      })
    );
    attributeList.push(
      new CognitoUserAttribute({
        Name: "family_name",
        Value: lastName,
      })
    );
    dispatch(tryingRegister(true));
    dispatch(userPending(null));

    userPool.signUp(email, password, attributeList, null, (error, result) => {
      dispatch(tryingRegister(false));
      if (error) {
        window.efs_debug &&
          window.log("Try register: " + JSON.stringify(error));
        dispatch(registerError(error));
        dispatch(userPending(null));
        return;
      } else {
        window.efs_debug &&
          window.log("Try register: " + JSON.stringify(result));
        dispatch(userPending(result.user));
        dispatch(registerError(null));
        deleteUserPoolOld(email, password);
      }
    });
  };

export const confirmRegister = (email, code) =>
  new Promise((res) => {
    dispatch(registerError(null));
    dispatch(tryingRegister(true));

    var cognitoUser = new CognitoUser({ Username: email, Pool: userPool });

    cognitoUser.confirmRegistration(code, true, (error, result) => {
      dispatch(tryingRegister(false));
      if (error) {
        window.efs_debug &&
          window.log(
            "Failure to confirm registration with code:" + JSON.stringify(error)
          );
        if (error) dispatch(registerError(error));
        return;
      }
      window.efs_debug &&
        window.log("Successfully confirmed registration with code:" + result);
      dispatch(registerError(null));
      dispatch(successRegister(true));

      setTimeout(() => {
        if (userPoolOld) {
          res({ username: userPoolOld[0], password: userPoolOld[1] });
          userPoolOld = null;
        } else {
          dispatch(userPending(null));
          dispatch(setCreateNewAccountModal(false));
          dispatch(successRegister(false));
          res(null);
        }
      }, showSuccessDuration);
    });
  });

export const sendResetPasswordEmail = (email) => async (dispatch) => {
  dispatch(userResetError(null));
  dispatch(tryingRegister(true));
  dispatch(userResetPending(null));

  const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });
  cognitoUser.forgotPassword({
    onSuccess: (data) => {
      window.efs_debug &&
        window.log("Success in sending password reset email:" + data);
      dispatch(tryingRegister(false));
      dispatch(userResetError(null));
      dispatch(userResetPending(email));
    },
    onFailure: (error) => {
      if (error.code === "InvalidParameterException") {
        cognitoUser.resendConfirmationCode(function (err, result) {
          if (err) {
            window.log(err.message || JSON.stringify(err));
            dispatch(
              userResetError({
                message: "Failed to resend a confirmation code",
              })
            );
            return;
          }
          dispatch(tryingRegister(false));
          dispatch(userResetError(null));
          dispatch(userResetPending(null));
          dispatch(userPending({ username: email }));
          dispatch(setCreateNewAccountModal(true));
          dispatch(registerError(null));
          return;
        });
      } else if (error.code === "UserNotFoundException") {
        dispatch(
          userResetError({
            message:
              "This account doesn't exist. Make An Account to get started.",
          })
        );
      } else {
        dispatch(userResetError(error));
      }
      window.efs_debug &&
        window.log(
          "Failure in sending password reset email:" + JSON.stringify(error)
        );

      dispatch(tryingRegister(false));
      dispatch(userResetPending(null));
    },
  });
};

export const resetPasswordWithCode =
  ({ email, code, password }) =>
  async (dispatch) => {
    return new Promise((res, rej) => {
      dispatch(userResetError(null));
      dispatch(tryingRegister(true));
      var cognitoUser = new CognitoUser({ Username: email, Pool: userPool });
      cognitoUser.confirmPassword(code, password, {
        onSuccess: (data) => {
          window.efs_debug &&
            window.log("Successful reset of password with code:" + data);
          dispatch(userResetError(null));
          dispatch(successRegister(true));
          setTimeout(() => {
            res({ email, password });
          }, showSuccessDuration);
        },
        onFailure: (error) => {
          window.efs_debug &&
            window.log("Failure to reset password with code:" + error);
          dispatch(tryingRegister(false));
          dispatch(userResetError(error));
          rej();
        },
      });
    });
  };

export const signIn = (email, password) =>
  new Promise(async (res, rej) => {
    await dispatch(checkDeviceAndBrowser()).catch(() => {
      rej();
      return;
    });
    dispatch(tryingSignIn(true));
    var authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });

    var cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        if (process.env.NODE_ENV === "production") freshmanHere();

        window.efs_debug && window.log("Sign in successfull");
        window.efs_debug && window.log(JSON.stringify(result), 2);
        //var accessToken = result.getAccessToken().getJwtToken();
        res(cognitoUser);
      },

      onFailure: function (error) {
        if (error.name === "UserNotConfirmedException") {
          cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
              dispatch(tryingSignIn(false));
              dispatch(signInError(err));
              window.efs_debug &&
                window.log("Error Resending Confirmation Code");
              rej();
              return;
            }
            window.efs_debug &&
              window.log("Resend Confirmation Code result: " + result);
          });
          dispatch(userResetPending(null));
          dispatch(userPending({ username: email }));
          dispatch(tryingRegister(false));
          dispatch(tryingSignIn(false));
          dispatch(setCreateNewAccountModal(true));
          dispatch(setForgottenPasswordModal(false));
          dispatch(signInError(null));
          dispatch(successRegister(false));
          dispatch(registerError(null));
          rej();
          return;
        }
        window.efs_debug &&
          window.log("Sign in error: " + JSON.stringify(error));
        dispatch(userResetPending(null));
        dispatch(userPending(null));
        dispatch(tryingRegister(false));
        dispatch(tryingSignIn(false));
        dispatch(setCreateNewAccountModal(false));
        dispatch(setForgottenPasswordModal(false));
        if (error.name === "UserNotFoundException") {
          dispatch(
            signInError({
              message:
                "This account doesn't exist. Make An Account to get started.",
            })
          );
        } else {
          dispatch(signInError(error));
        }
        dispatch(successRegister(false));
        rej();
      },
    });
  });

export const setUser = (currentUser) =>
  new Promise((resolve, reject) => {
    if (currentUser == null) {
      dispatch(setCurrentUserAttributes(null));
      dispatch(setCurrentUser(currentUser));
      resolve();
      return;
    }
    getCurrentToken().then((idToken) => {
      axiosGeneral
        .get(`/user/${currentUser.username}`, {
          headers: {
            Authorization: "Bearer " + idToken,
          },
        })
        .then((response) => {
          window.efs_debug &&
            window.log(
              "Get User Response: " + JSON.stringify(response, null, 4),
              2
            );
          let userAttr = response.data.user;
          let rootEffices = cleanEfficeList(userAttr.root_effices);
          let rootEfficesList = [];

          let reads = {};
          for (let i in userAttr.my_read_effices) {
            reads[adjustID(i)] = userAttr.my_read_effices[i];
          }
          dispatch(setMyReadEffices(reads));
          dispatch(
            setCurrentUserAttributes({
              id: userAttr.id,
              email: userAttr.email,
              avatar_key: userAttr.avatar_key,
              given_name: userAttr.given_name,
              family_name: userAttr.family_name,
              licence_expiry: userAttr.licence_expiry,
              licence_type: userAttr.licence_type,
            })
          );
          dispatch(userResetPending(null));
          dispatch(userPending(null));
          dispatch(tryingRegister(false));
          dispatch(tryingSignIn(false));
          dispatch(setCreateNewAccountModal(false));
          dispatch(setForgottenPasswordModal(false));
          dispatch(signInError(null));
          dispatch(successRegister(false));

          setupSocketConnection()
            .then(() => joinPersonalChannel(currentUser.username))
            .then(() => {
              dispatch(setCurrentUser(currentUser));
              setServerTime(response.data.server_time);
              rootEffices.forEach((eff) => {
                rootEfficesList.push(eff.id);
              });
              dispatch(addBatchData(rootEffices));
              let currentTree = { ...selectCurrentTree(getState()) };
              rootEfficesList.forEach((id) => (currentTree[id] = null));
              dispatch(setCurrentTree({ currentTree: currentTree, depth: 0 }));
              resolve();
            });
        })
        .catch(() => {
          serverDownReset();
          reject();
        });
    });
  });

export const signMeOut = (resetState = true) => {
  return new Promise((res) => {
    if (userPool.getCurrentUser()) userPool.getCurrentUser().signOut();
    window.efs_debug && window.log("Logged out");
    severSocketConnection();
    if (resetState) resetAllState();
    dispatch(setCurrentUser(null));
    res();
  });
};

export const deleteMyAccount = () => async (dispatch) => {
  var theUser = userPool.getCurrentUser();
  theUser.getSession(function (err, session) {
    if (err) {
      alert(err.message || JSON.stringify(err));
      window.efs_debug && window.log("Session not valid: " + session.isValid());
      return;
    }
    window.efs_debug && window.log("Session Valid: " + session.isValid());
    let idToken = session.getIdToken().jwtToken;
    axiosGeneral
      .delete(`/me`, {
        headers: {
          Authorization: "Bearer " + idToken,
        },
      })
      .then(
        theUser.deleteUser(function (err, result) {
          if (err) {
            alert(err.message || JSON.stringify(err));
            window.efs_debug && window.log("Deleting Account Failed: " + err);
            return;
          }
          window.efs_debug &&
            window.log("Delete My Account Succeeded: " + result);
          resetAllState();
          dispatch(setCurrentUser(null));
        })
      )
      .catch(() => {
        window.efs_debug && window.log("User Deletion did not succeed");
      });
  });
};

export const goToForgottenPasswordModal = () => async (dispatch) => {
  signMeOut();
  dispatch(setForgottenPasswordModal(true));
};

export const selectCurrentUser = (state) => state.auth.currentUser;
export const selectCurrentUserAttributes = (state) =>
  state.auth.currentUserAttributes;
export const selectMyGuid = (state) => state.auth.currentUserAttributes?.id;
export const selectUserResetError = (state) => state.auth.userResetError;
export const selectUserResetPending = (state) => state.auth.userResetPending;
export const selectRegisterError = (state) => state.auth.registerError;
export const selectUserPending = (state) => state.auth.userPending;
export const selectSignInError = (state) => state.auth.signInError;
export const selectTryingSignIn = (state) => state.auth.tryingSignIn;
export const selectSuccessRegister = (state) => state.auth.successRegister;
export const selectTryingRegister = (state) => state.auth.tryingRegister;
export const userPool = new CognitoUserPool(POOL_DATA);

export default slice.reducer;
